import React, { useContext, useEffect, useState } from "react";
import styles from "./HeadphoneCalib.module.scss";
import axios from "axios";

import Button from "../../UiComponents/Button";
import Loader from "../../UiComponents/loader/Loader";
import Success from "../../UiComponents/sucess/Success";
import headphone from "../../../pics/casquePdf.png";
import neuronalHeadphones from "../../../pics/neuronal_headphones.png";
import imageDragon from "../../../pics/dragonFly.png";

import { IoIosArrowDropdown, IoIosArrowDropup } from "react-icons/io";
import {
  displayCalibValue,
  ticksToDate,
  ticksToDateYearMonthDay,
} from "../../calibration/functionDataSorted";

import NavContext from "../../../context/NavContext";
import Axios from "../../../_services/caller.service";
import { convertDateToTicks } from "../../../utils/handleDateTicks";
import download from "downloadjs";
import DropZone from "../../UiComponents/dropZone/DropZone";
import ModalNotGoodOupout from "./Modal/ModalNotGoodOupout";
import ModalComfirmImport from "./Modal/ModalComfirmImport";
import ModalConfirmRegisterNewValue from "./Modal/ModalConfirmRegisterNewValue";
import { decodedB64, encodedB64 } from "../../../CustomHooks/DecodedBase64";
import { toast } from "react-toastify";
import LoaderLogin from "../../UiComponents/loader/LoaderLogin";
import MiniCardToggle from "../../UiComponents/card/MiniCardToggle";
import { PermissionGate } from "../managePermissions/PermissionGate";
import { useTranslation } from "react-i18next";
import { DEFAULT_HEADPHONES_CALIBRATION } from "./defaultCalibrationData";
import ModalConfirmDefaultCalib from "./Modal/ModalConfirmDefaultCalib";

const HeadphoneCalib = ({ cabId, setCabId, cabname, onCalibrationSaved }) => {
  const { t } = useTranslation();
  // CALIBRATION

  const [calibGeneral, setCalibGeneral] = useState("");
  const [calibTonalLeft, setCalibTonalLeft] = useState([]);
  const [calibTonalRight, setCalibTonalRight] = useState([]);
  const [calibVocalLeft, setCalibVocalLeft] = useState([]);
  const [calibVocalRight, setCalibVocalRight] = useState([]);
  //SERIAL NUMBER HEADPHONES AND SOUNDCARD

  const [serialNumber, setSerialNumber] = useState("");
  const [serialSoundcardNumber, setSerialSoundcardNumber] = useState("");
  const [importSerialNumber, setImportSerialNumber] = useState(true);
  const [importSoundcardSerial, setImportSoundcardSerial] = useState(true);

  const [microphoneName, setMicrophoneName] = useState("");
  const [microphoneSerial, setMicrophoneSerial] = useState("");

  //DISPLAY
  const [displayHeadphone, setdisplayHeadphone] = useState(false);
  const [dateCalibration, setDateCalibration] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSucess] = useState(false);
  const [maj, setMaj] = useState(false);
  //LOADING
  const [loadingVoc, setloadingVoc] = useState(true);
  const [loadingTon, setloadingTon] = useState(true);
  const [loadingGen, setloadingGen] = useState(true);
  const [loadingCalibrationTonalForDate, setLoadingCalibrationTonalForDate] =
    useState(true);

  const [loadingAllData, setLoadingAllData] = useState(true);
  //IMPORT EXPORT FILE TXT
  const [selectedFile, setSelectedFile] = useState();
  const [modalConfirmImport, setModalConfirmImport] = useState(false);
  const [modalConfirmRegisterNewValue, setModalConfirmRegisterNewValue] =
    useState(false);
  const [modalNotGoodOutpout, setModalNotGoodOutpout] = useState(false);
  const [overlay, setOverlay] = useState(false);
  const [isCheckedDateUpdate, setIsCheckedDateUpdate] = useState(false);
  const [warningMessage, setWarningMessage] = useState("");

  const [previousCalibGeneral, setPreviousCalibGeneral] = useState("");
  const [previousCalibTonalLeft, setPreviousCalibTonalLeft] = useState([]);
  const [previousCalibTonalRight, setPreviousCalibTonalRight] = useState([]);
  const [previousCalibVocalLeft, setPreviousCalibVocalLeft] = useState([]);
  const [previousCalibVocalRight, setPreviousCalibVocalRight] = useState([]);
  const [previousDateCalibration, setPreviousDateCalibration] = useState("");
  const [previousSerialNumber, setPreviousSerialNumber] = useState("");
  const [previousSerialSoundcardNumber, setPreviousSerialSoundcardNumber] =
    useState("");
  const [importedSerialNumber, setImportedSerialNumber] = useState("");
  const [importedSoundcardSerialNumber, setImportedSoundcardSerialNumber] =
    useState("");
  const [isImportMode, setIsImportMode] = useState(false);
  const [modalDefaultCalib, setModalDefaultCalib] = useState(false);
  const [pendingDefaultSave, setPendingDefaultSave] = useState(false);

  // CONTROLLER
  const controller = new AbortController();
  const signal = controller.signal;

  const frequencies = [
    "125Hz",
    "250Hz",
    "500Hz",
    "750Hz",
    "1Khz",
    "1.5Khz",
    "2Khz",
    "3Khz",
    "4Khz",
    "6KHz",
    "8KHz",
  ];

  useEffect(() => {
    if (cabId !== "") {
      const controller = new AbortController();
      const signal = controller.signal;

      const fetchGeneral = Axios.get(`/calibrationGeneral/${cabId}`, { signal })
        .then((response) => {
          setloadingGen(false);
          if (response.data.message === "aucune donnée") {
            setCalibGeneral("0");
          } else {
            const allValueHead = response.data.data;
            const valueGeneral = displayCalibValue(
              allValueHead,
              "Headphones_Value"
            );
            // n° de serie casque
            const serialNumberHeadphones = displayCalibValue(
              allValueHead,
              "Headphones_Serial"
            );
            setSerialNumber(decodedB64(serialNumberHeadphones));
            // n° de serie carte son casque
            const serialNumberHeadphonesSoundcard = displayCalibValue(
              allValueHead,
              "Headphones_Soundcard_Serial"
            );
            setSerialSoundcardNumber(
              decodedB64(serialNumberHeadphonesSoundcard)
            );
            const micsName = displayCalibValue(
              allValueHead,
              "Headphones_MicrophoneName"
            )[0];
            setMicrophoneName(decodedB64(micsName));
            const micsSerial = displayCalibValue(
              allValueHead,
              "Headphones_MicrophoneSerial"
            )[0];
            setMicrophoneSerial(micsSerial);
            if (valueGeneral.length >= 1) {
              setCalibGeneral(valueGeneral[0]);
            } else {
              setCalibGeneral("0");
            }
            const dateGeneral = displayCalibValue(
              allValueHead,
              "Headphones_Passed"
            )[0];
            return dateGeneral;
          }
        })
        .catch((error) => {
          console.log(error);
        });

      const fetchTonal = Axios.get(`/calibrationTonal/${cabId}`, { signal })
        .then((response) => {
          setloadingTon(false);
          if (response.data.message === "aucune donnée") {
            setCalibTonalLeft([
              "0",
              "0",
              "0",
              "0",
              "0",
              "0",
              "0",
              "0",
              "0",
              "0",
              "0",
            ]);
            setCalibTonalRight([
              "0",
              "0",
              "0",
              "0",
              "0",
              "0",
              "0",
              "0",
              "0",
              "0",
              "0",
            ]);
            setSerialNumber("");
            setSerialSoundcardNumber("");
          } else {
            const allValueHead = response.data.data;
            const valueTonal = displayCalibValue(
              allValueHead,
              "Headphones_Value"
            );
            if (valueTonal.length >= 1) {
              const dataLeft = valueTonal[0].split(",").slice(0, 11);
              const dataRight = valueTonal[0].split(",").slice(11, 22);

              setCalibTonalLeft(dataLeft);
              setCalibTonalRight(dataRight);
            } else {
              setCalibTonalLeft([
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
              ]);
              setCalibTonalRight([
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
              ]);
            }
            const dateTonal = displayCalibValue(
              allValueHead,
              "Headphones_Passed"
            )[0];
            return dateTonal;
          }
        })
        .catch((error) => {
          console.log(error);
        });

      const fetchVocal = Axios.get(`/calibrationVocal/${cabId}`, { signal })
        .then((response) => {
          setloadingVoc(false);
          if (response.data.message === "aucune donnée") {
            setCalibVocalLeft("0");
            setCalibVocalRight("0");
          } else {
            const allValueHead = response.data.data;
            const valueVocal = displayCalibValue(
              allValueHead,
              "Headphones_Value"
            );
            if (valueVocal.length >= 1) {
              const dataLeft = valueVocal[0].split(",").slice(0, 1);
              const dataRight = valueVocal[0].split(",").slice(1, 2);
              setCalibVocalLeft(dataLeft);
              setCalibVocalRight(dataRight);
            } else {
              setCalibVocalLeft("0");
              setCalibVocalRight("0");
            }
            const dateVocal = displayCalibValue(
              allValueHead,
              "Headphones_Passed"
            )[0];
            return dateVocal;
          }
        })
        .catch((error) => {
          console.log(error);
        });
      Promise.all([fetchGeneral, fetchTonal, fetchVocal]).then(
        ([dateGeneral, dateTonal, dateVocal]) => {
          const allDatesExist = dateGeneral && dateTonal && dateVocal;

          if (allDatesExist) {
            setDateCalibration(dateTonal); // Utiliser dateGeneral comme exemple
            setWarningMessage(""); // Pas de message d'avertissement nécessaire
            setLoadingCalibrationTonalForDate(false);
          } else {
            setDateCalibration("");
            setDateCalibration("");
            setCalibTonalLeft([
              "0",
              "0",
              "0",
              "0",
              "0",
              "0",
              "0",
              "0",
              "0",
              "0",
              "0",
            ]);
            setCalibTonalRight([
              "0",
              "0",
              "0",
              "0",
              "0",
              "0",
              "0",
              "0",
              "0",
              "0",
              "0",
            ]);
            setCalibGeneral("0");
            setCalibVocalLeft("0");
            setCalibVocalRight("0");
            setLoadingCalibrationTonalForDate(false);
            // Ne pas définir de message d'avertissement si toutes les dates sont absentes
          }
        }
      );

      return () => {
        controller.abort();
      };
    }
  }, [cabId, setCabId, maj]);

  //UPDATE CALIB TONAL STATE
  const updateFrequenciesValueLeft = (id, e) => {
    const newState = calibTonalLeft.map((obj, index) => {
      if (id === index) {
        const newValue = e.target.value; //valeur de l'input
        return newValue;
      }

      return obj;
    });

    setCalibTonalLeft(newState);
  };
  const updateFrequenciesValueRight = (id, e) => {
    const newState = calibTonalRight.map((obj, index) => {
      if (id === index) {
        const newValue = e.target.value; //valeur de l'input
        return newValue;
      }

      return obj;
    });

    setCalibTonalRight(newState);
  };

  const registerNewValueHeadphones = (params) => {
    const finalSerialNumber = isImportMode
      ? importSerialNumber
        ? importedSerialNumber
        : previousSerialNumber
      : serialNumber;

    const finalSerialSoundcardNumber = isImportMode
      ? importSoundcardSerial
        ? importedSoundcardSerialNumber
        : previousSerialSoundcardNumber
      : serialSoundcardNumber;

    // Encodage en Base64 seulement si un numéro est fourni
    const serialNumberEncoded = finalSerialNumber
      ? encodedB64(finalSerialNumber)
      : "";
    const serialNumberSoundCardEncoded = finalSerialSoundcardNumber
      ? encodedB64(finalSerialSoundcardNumber)
      : "";

    const date =
      isCheckedDateUpdate || !dateCalibration
        ? convertDateToTicks()
        : dateCalibration; // date now or date old
    //create catid if they don't exist in DB
    Axios.post(`/createCatid/${cabId}`)

      .then((response) => {
        toast.success(response.data.message);

        // if they exist or if they are created we register calib data
        Axios.put(`/newValueHeadGeneral/${cabId}`, {
          data: { calibGeneral: calibGeneral, date: date },
        })

          .then((response) => {
            setLoading(false);
          })
          .catch(function (error) {
            console.log(error);
          });
        Axios.put(`/newValueHeadTonal/${cabId}`, {
          calibTonalLeft: calibTonalLeft,
          calibTonalRight: calibTonalRight,
          date: date,
        })

          .then((response) => {
            setLoading(false);
          })
          .catch(function (error) {
            console.log(error);
          });
        Axios.put(`/newValueHeadphonesSerial/${cabId}`, {
          data: serialNumberEncoded,
        })

          .then((response) => {
            setLoading(false);
          })
          .catch(function (error) {
            console.log(error);
          });
        Axios.put(`/newValueHeadphonesSoundcardSerial/${cabId}`, {
          data: serialNumberSoundCardEncoded,
        })

          .then((response) => {
            setLoading(false);
          })
          .catch(function (error) {
            console.log(error);
          });
        Axios.put(`/newValueHeadVocal/${cabId}`, {
          calibVocalLeft: calibVocalLeft,
          calibVocalRight: calibVocalRight,
          date: date,
        })

          .then((response) => {
            setOverlay(false); // dans le cas d'import
            setModalConfirmImport(false); // dans le cas d'import
            setModalConfirmRegisterNewValue(false); // dans le cas de nouvelle valeur
            setMaj(!maj);
            toast.success(t("calibration_data.all_data_saved"));
            if (onCalibrationSaved) onCalibrationSaved();
          })
          .catch(function (error) {
            console.log(error);
          });
      })
      .catch(function (error) {
        if (error.response) {
          // Si une réponse avec un message d'erreur est reçue du backend
          const errorMessage = error.response.data.message;

          toast.error(errorMessage, {
            autoClose: false,
          });
        } else {
          toast.error(
            t("calibration_data.error_occurred"),
            {
              autoClose: false,
            }
          );
        }
      });
  };

  const checkHandler = () => {
    setIsCheckedDateUpdate(!isCheckedDateUpdate);
  };

  //IMPORT AND EXPORT CALIBRATION DATA

  const exportCalibDataHead = async () => {
    const calibDate = ticksToDateYearMonthDay(dateCalibration);
    //Tonal Value
    const allValueTonal = calibTonalLeft.concat(calibTonalRight);

    //VocalValue
    const arrayVocalLeft = Array.isArray(calibVocalLeft)
      ? calibVocalLeft
      : [calibVocalLeft];
    const arrayVocalRight = Array.isArray(calibVocalRight)
      ? calibVocalRight
      : [calibVocalRight];

    // Concatenate the arrays
    const allValueVocal = arrayVocalLeft.concat(arrayVocalRight);

    const data = {
      Eoutpout: "Headphones",
      date: dateCalibration,
      general: calibGeneral,
      vocal: allValueVocal,
      tonal: allValueTonal,
      serialNumber: serialNumber, // Add serial number
      serialSoundcardNumber: serialSoundcardNumber, // Add soundcard serial number
    };

    const dataStr = JSON.stringify(data);

    const filename = `Headphones Calibration Data - ${serialNumber} - ${serialSoundcardNumber} - [${cabname}(${cabId})] - ${calibDate}.txt`;
    const filetype = "text/plain";

    // Download the file
    download(dataStr, filename, filetype);
  };

  const fileChangedHandler = (file) => {
    setSelectedFile(file);
  };

  useEffect(() => {
    if (selectedFile) {
      importCalibDataHead();
    }
  }, [selectedFile]);

  const importCalibDataHead = () => {
    const reader = new FileReader();

    reader.onload = async (e) => {
      // The file's text will be printed here
      const text = e.target.result;
      const data = JSON.parse(text);

      if (data.Eoutpout !== "Headphones") {
        setModalNotGoodOutpout(true);
        setOverlay(true);
        return;
      }

      const headGeneral = data.general;
      const headVocalLeft = data.vocal.slice(0, 1);
      const headVocalRight = data.vocal.slice(1, 2);
      const headTonalLeft = data.tonal.slice(0, 11);
      const headTonalRight = data.tonal.slice(11, 22);
      const date = data.date;
      const importedSerial = data.serialNumber || "";
      const importedSerialSoundcardSerial = data.serialSoundcardNumber || "";

      // Sauvegarde des anciennes valeurs AVANT d'afficher les nouvelles
      setPreviousCalibGeneral(calibGeneral);
      setPreviousCalibTonalLeft(calibTonalLeft);
      setPreviousCalibTonalRight(calibTonalRight);
      setPreviousCalibVocalLeft(calibVocalLeft);
      setPreviousCalibVocalRight(calibVocalRight);
      setPreviousDateCalibration(date);
      setPreviousSerialNumber(serialNumber); // Set the serial number
      setPreviousSerialSoundcardNumber(serialSoundcardNumber); // Set the soundcard serial number

      setCalibGeneral(headGeneral);
      setCalibTonalLeft(headTonalLeft);
      setCalibTonalRight(headTonalRight);
      setCalibVocalLeft(headVocalLeft);
      setCalibVocalRight(headVocalRight);
      setDateCalibration(date);

      setIsImportMode(true); // On active le mode import

      if (importedSerial) {
        setSerialNumber(importedSerial);
      }
      if (importedSerialSoundcardSerial) {
        setSerialSoundcardNumber(importedSerialSoundcardSerial);
      }

      // Stocke les valeurs importées
      setImportedSerialNumber(importedSerial);
      setImportedSoundcardSerialNumber(importedSerialSoundcardSerial);
      setModalConfirmImport(true);
      setOverlay(true);
    };

    reader.readAsText(selectedFile);
  };

  const handleSerialNumberChange = (
    importSerialNumber,
    importSoundcardSerial
  ) => {
    setSerialNumber(
      importSerialNumber ? importedSerialNumber : previousSerialNumber
    );
    setSerialSoundcardNumber(
      importSoundcardSerial
        ? importedSoundcardSerialNumber
        : previousSerialSoundcardNumber
    );
  };

  const injectDefaultCalibration = () => {
    const data = DEFAULT_HEADPHONES_CALIBRATION;
    const date = convertDateToTicks();

    setCalibGeneral(data.general);
    setCalibVocalLeft(data.vocal.slice(0, 1));
    setCalibVocalRight(data.vocal.slice(1, 2));
    setCalibTonalLeft(data.tonal.slice(0, 11));
    setCalibTonalRight(data.tonal.slice(11, 22));
    setDateCalibration(date);
    setIsCheckedDateUpdate(true);
    setPendingDefaultSave(true);
  };

  useEffect(() => {
    if (pendingDefaultSave) {
      setPendingDefaultSave(false);
      registerNewValueHeadphones();
    }
  }, [pendingDefaultSave]);

  // Surveiller tous les états de chargement
  useEffect(() => {
    if (
      !loadingGen &&
      !loadingTon &&
      !loadingVoc &&
      !loadingCalibrationTonalForDate
    ) {
      setLoadingAllData(false); // Tout est chargé
    }
  }, [loadingGen, loadingTon, loadingVoc, loadingCalibrationTonalForDate]);
  return (
    <>
      {loadingAllData && <LoaderLogin />}

      <div className={styles.containerBoneCalib}>
        {overlay && <div className={styles.overlay}></div>}
                <img className={styles.currentCalibrationImg} src={neuronalHeadphones} alt="" />
         <div className={styles.cabnameAndType}>
                  <h2>Calibration Casque ➡️ </h2>
                  <h3>
                    {cabname}({cabId})
                  </h3>
                </div>
        <div className={styles.containerBtnExport}>
               <PermissionGate actionKey="cabines.transducers.calibration.export">
          <Button
            onPress={exportCalibDataHead}
            styles={"btnExport"}
            text={t("calibration_data.export")}
          /></PermissionGate>
          <div className={styles.containerImport}>
            <div className={styles.containerInputImport}>
           <label className={styles.uploadLabel}>
                                    {t("calibration_data.select_file")}
                                    <PermissionGate actionKey="cabines.transducers.calibration.import">
                                      <input
                                        type="file"
                                        onChange={(e) => fileChangedHandler(e.target.files[0])}
                                        className={styles.hiddenInput}
                                      />
                                    </PermissionGate>
                                  </label>
              
            </div>
          </div>
          <PermissionGate actionKey="cabines.transducers.calibration.import">
            <button
              type="button"
              className={styles.uploadLabel}
              onClick={() => {
                setOverlay(true);
                setModalDefaultCalib(true);
              }}
            >
              Injecter les calibrations par défaut
            </button>
          </PermissionGate>
        </div>
        {modalNotGoodOutpout && (
          <ModalNotGoodOupout
            setOverlay={setOverlay}
            setModalNotGoodOutpout={setModalNotGoodOutpout}
          />
        )}

        {modalDefaultCalib && (
          <ModalConfirmDefaultCalib
            setOverlay={setOverlay}
            setModalOpen={setModalDefaultCalib}
            type="Headphones"
            onConfirm={injectDefaultCalibration}
          />
        )}

        {/* {modalConfirmImport && (
            <ModalComfirmImport
              setModalConfirmImport={setModalConfirmImport}
              setOverlay={setOverlay}
              isCheckedDateUpdate={isCheckedDateUpdate}
              checkHandler={checkHandler}
              setMaj={setMaj}
              maj={maj}
              registerNewValue={registerNewValueHeadphones}
            />
          )} */}
     
        {/* debut generale */}
        <div className={styles.containerValue}>
          <div className={styles.general}>
            <h4>{t("calibration_data.general_correction")}</h4>
            <input
              onChange={(e) => setCalibGeneral(e.target.value)}
              onWheel={() => document.activeElement.blur()}
              value={calibGeneral}
              type="number"
              step="0.1"
            />
          </div>
          {/* fin generale */}

          <h5>{t("calibration_data.tonal_correction")}</h5>
          <div className={styles.tableScroll}>
            <table className={styles.calibTable}>
              <thead>
                <tr>
                  <th></th>
                  {frequencies.map((freq, index) => (
                    <th key={index}>{freq}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className={styles.rowLabel}>G</td>
                  {calibTonalLeft.map((value, index) => (
                    <td key={index}>
                      <input
                        onChange={(e) => updateFrequenciesValueLeft(index, e)}
                        onWheel={() => document.activeElement.blur()}
                        type="number"
                        step="0.1"
                        value={value}
                      />
                    </td>
                  ))}
                </tr>
                <tr>
                  <td className={styles.rowLabel}>D</td>
                  {calibTonalRight.map((value, index) => (
                    <td key={index}>
                      <input
                        onChange={(e) => updateFrequenciesValueRight(index, e)}
                        onWheel={() => document.activeElement.blur()}
                        type="number"
                        step="0.1"
                        value={value}
                      />
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className={styles.containerVocale}>
          <h4 className={styles.vocaleTitle}>{t("calibration_data.vocal_correction")}</h4>
          <table className={styles.calibTable}>
            <tbody>
              <tr>
                <td className={styles.rowLabel}>G</td>
                <td>
                  <input
                    onChange={(e) => setCalibVocalLeft(e.target.value)}
                    onWheel={() => document.activeElement.blur()}
                    type="number"
                    step="0.1"
                    value={calibVocalLeft}
                  />
                </td>
              </tr>
              <tr>
                <td className={styles.rowLabel}>D</td>
                <td>
                  <input
                    onChange={(e) => setCalibVocalRight(e.target.value)}
                    onWheel={() => document.activeElement.blur()}
                    type="number"
                    step="0.1"
                    value={calibVocalRight}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* fin vocale */}
        {/* SERIAL */}
        <div className={styles.containerAllSerial}>
          <div className={styles.containerSerial}>
            <div className={styles.serial}>
              <h4>{t("calibration_data.mic_name")}</h4>

              <span>{microphoneName}</span>
            </div>
            <div className={styles.serial}>
              <h4>{t("calibration_data.mic_serial")}</h4>

              <span>{microphoneSerial}</span>
            </div>
            <div className={styles.serial}>
              <h4>{t("calibration_data.headphone_serial")}</h4>

              <input
                onChange={(e) => setSerialNumber(e.target.value)}
                type="text"
                value={serialNumber}
              ></input>
              <img src={headphone} alt="" />
            </div>
            <div className={styles.serial}>
              <h4>{t("calibration_data.soundcard_serial")}</h4>
              <input
                onChange={(e) => setSerialSoundcardNumber(e.target.value)}
                type="text"
                value={serialSoundcardNumber}
              ></input>
              <img src={imageDragon} alt="" />
            </div>
          </div>
        </div>
        <div className={styles.containerBtn}>
            <PermissionGate actionKey="cabines.transducers.calibration.update">
          <Button
            onPress={() => {
              setOverlay(true);
              setModalConfirmRegisterNewValue(true);
              isImportMode && setIsImportMode(false); // Désactiver le mode import
            }}
            styles={"btnValidation"}
            text={t("calibration_data.save_new_values")}
          /></PermissionGate>
          {(modalConfirmRegisterNewValue || modalConfirmImport) && (
            <ModalConfirmRegisterNewValue
              setModalConfirmImport={setModalConfirmImport}
              setModalConfirmRegisterNewValue={setModalConfirmRegisterNewValue}
              setOverlay={setOverlay}
              isCheckedDateUpdate={isCheckedDateUpdate}
              checkHandler={checkHandler}
              importSerialNumber={importSerialNumber}
              setImportSerialNumber={setImportSerialNumber}
              importSoundcardSerial={importSoundcardSerial}
              setImportSoundcardSerial={setImportSoundcardSerial}
              registerNewValue={registerNewValueHeadphones}
              setCalibGeneral={setCalibGeneral}
              setCalibTonalLeft={setCalibTonalLeft}
              setCalibTonalRight={setCalibTonalRight}
              setCalibVocalLeft={setCalibVocalLeft}
              setCalibVocalRight={setCalibVocalRight}
              setDateCalibration={setDateCalibration}
              setSerialNumber={setSerialNumber}
              setSerialSoundcardNumber={setSerialSoundcardNumber}
              // Passer les anciennes valeurs sauvegardées
              previousCalibGeneral={previousCalibGeneral}
              previousCalibTonalLeft={previousCalibTonalLeft}
              previousCalibTonalRight={previousCalibTonalRight}
              previousCalibVocalLeft={previousCalibVocalLeft}
              previousCalibVocalRight={previousCalibVocalRight}
              previousDateCalibration={previousDateCalibration}
              previousSerialNumber={previousSerialNumber}
              previousSerialSoundcardNumber={previousSerialSoundcardNumber}
              importedSerialNumber={importedSerialNumber} // Ajout de la nouvelle variable
              importedSoundcardSerialNumber={importedSoundcardSerialNumber} // Ajout de la nouvelle variable
              handleSerialNumberChange={handleSerialNumberChange}
              isImportMode={isImportMode}
              maj={maj}
              setMaj={setMaj}
            />
          )}
          {loading && <Loader />}
          {success && <Success success={t("calibration_data.calibration_data_updated")} />}
        </div>
      </div>
    </>
  );
};

export default HeadphoneCalib;
